module.exports = __webpack_public_path__ + "img/Afterpay_BookNow_Banner_600x150_White@1x.f614b806.png";